import { gql, useQuery } from '@apollo/client';
import { systemAlertQuery, systemAlertQueryVariables } from '../core-types';
import { bootstrap } from '../lib/bootstrap';
import { CustomNextPage } from '../lib/types';
import { getQueryString } from '../lib/utils';
import Layout from '../modules/Layout';
import Status from '../modules/SystemStatus/Status';

const SYSTEM_ALERT_QUERY = gql`
  query systemAlertQuery($id: ID!) {
    systemAlert(id: $id) {
      id
      resolvedAt
      dockGroups {
        id
        title
      }
      systemAlertType
      incidentStartTime
      incidentEndTime
      title
      description
      slug {
        current
      }
      updates {
        id
        createdAt
        title
        description
      }
      visibility
      isDismissible
    }
  }
`;

const SystemStatusPage: CustomNextPage<{}> = props => {
  const { url } = props;

  // We enable this feature flag to show the system status page

  // if (!systemConfig.featureFlags.enableSystemAlerts) {
  //   const err = new Error(`Page not found`);
  //   err.code = 'ENOENT';
  //   throw err;
  // }

  const { subSlug: firstQueryParam, statusId: secondQueryParam } = url.query;
  const hasBothSlugAndStatusId = secondQueryParam && secondQueryParam !== '';
  const _statusId = hasBothSlugAndStatusId ? secondQueryParam : firstQueryParam;
  const statusId = getQueryString(_statusId);

  if (!statusId) {
    const err = new Error(`Page not found`);
    err.code = 'ENOENT';
    throw err;
  }

  const { data, loading } = useQuery<
    systemAlertQuery,
    systemAlertQueryVariables
  >(SYSTEM_ALERT_QUERY, { variables: { id: statusId } });

  const title = data && data.systemAlert && data.systemAlert.title;
  return (
    <Layout
      title={title}
      url={url}
      loading={loading}
      contentProps={{
        // Override Content defaultProps
        py: 0,
        mx: 0,
        my: 5
      }}
      render={() => {
        if (!data || !data.systemAlert) {
          const err = new Error('Page not found');
          err.code = 'ENOENT';
          throw err;
        }

        return <Status {...props} systemAlert={data.systemAlert} />;
      }}
    />
  );
};

export default bootstrap(SystemStatusPage);
